import React, { Component } from 'react'
import { SinglePanel } from 'components/common/panel'
import { useGlobalContext } from 'components/context'
import ModuleCard from './card'
import * as styles from './index.module.sass'

const AddModule = () => {
	const { organisation } = useGlobalContext()
	return (
		<div className={styles.containerOuter}>
			<div className={styles.container}>
				<h4>Activate {organisation.suite.moduleWord}</h4>
				<div className={styles.cardContainer}>
					{organisation.suite.moduleSetItems.map(msi => (
						<ModuleCard key={msi.module.id} module={msi.module} />
					))}
				</div>
			</div>
		</div>
	)
}

export default AddModule